import React, { useEffect, useState } from "react";
import { EntypoArrowLeft, EntypoChevronLeft } from "react-entypo-icons";
import { getPlatform } from "../config";

function Header({title, onBackButtonClicked, backButtonExtraStyle, titleExtraStyle}) {
  const [platform, setPlatform] = useState("unknown");

  useEffect(() => {
    const platformName = getPlatform();
    setPlatform(platformName);
  }, []);

  return (
    <div className={`d-flex align-items-center px-2 ${backButtonExtraStyle}`}>
      <div style={{cursor: "pointer", color: 'white'}} onClick={onBackButtonClicked}>
        {platform === "Android" ? (
          <EntypoArrowLeft style={{ fontSize: 20}} />
        ) : (
          <EntypoChevronLeft style={{ fontSize: 20}} />
        )}
      </div>
      <h4 className={`my-0 mx-2 ${titleExtraStyle} text-white`} >{title}</h4>
    </div>
  );
}

export default Header;
